import React from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { MobileTabBar } from "@/components/MobileTabBar";
import { useAuth } from "@/context/AuthContext";

export function Layout({ children }) {
  const { user } = useAuth();
  const authed = user && typeof user === "object";
  return (
    <div className="flex min-h-screen flex-col bg-[#faf9f6]">
      <Navbar />
      <main className={`flex-1 ${authed ? "pb-20 lg:pb-0" : ""}`}>{children}</main>
      <Footer />
      <MobileTabBar />
    </div>
  );
}

export default Layout;
